import { useState, useCallback } from "react";

import { ButtonWithIcon } from "components/UI/ButtonWithIcon/ButtonWithIcon";

import chevron from "assets/images/chevron.svg";

import "./CompactView.scss";

const CompactView = ({
  slides,
  itemsVisible,
  itemHeight,
  onSlideClick,
  withRightFade = false,
  mobileExtraButton = null,
  isMobile,
}) => {
  const itemWidth = 100 / itemsVisible;
  const maxIndex = slides.length - itemsVisible;
  const [current, setCurrent] = useState(0);

  const handleClick = (slide) => {
    if (onSlideClick) {
      onSlideClick(slide);
      return;
    }
    if (slide.link) {
      window.open(slide.link, "_blank", "noopener,noreferrer");
    }
  };

  const handlePrev = useCallback(() => {
    setCurrent((prev) => (prev <= 0 ? maxIndex : prev - 1));
  }, [maxIndex]);

  const handleNext = useCallback(() => {
    setCurrent((prev) => (prev >= maxIndex ? 0 : prev + 1));
  }, [maxIndex]);

  return (
    <div className="compact-view">
      {!isMobile && (
        <ButtonWithIcon
          className="carousel__button-prev"
          icon={chevron}
          onClick={handlePrev}
        />
      )}

      <div
        className={`compact-view__viewport ${
          withRightFade ? "compact-view__viewport--fade-right" : ""
        }`}
      >
        <div
          className="compact-view__track"
          style={{ transform: `translateX(-${itemWidth * current}%)` }}
        >
          {slides.map((slide, index) => (
            <img
              className="compact-view__item"
              key={index}
              src={slide.image}
              alt=""
              style={{ minWidth: `${itemWidth}px`, height: itemHeight }}
              onClick={() => handleClick(slide)}
            />
          ))}
        </div>
      </div>

      {!isMobile && (
        <ButtonWithIcon
          className="carousel__button-next"
          icon={chevron}
          onClick={handleNext}
        />
      )}

      {isMobile && (
        <div className="compact-view__buttons">
          {mobileExtraButton && mobileExtraButton}
          <div className="compact-view__nav-buttons">
            <ButtonWithIcon
              className="carousel__button-prev"
              icon={chevron}
              onClick={handlePrev}
            />
            <ButtonWithIcon
              className="carousel__button-next"
              icon={chevron}
              onClick={handleNext}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CompactView;